import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { ReplaySubject, Observable } from 'rxjs';
import { SxContextService } from './sxContext.service';
import { CacheService } from './cache.service';
import { SxTranslationService } from './translation-service.service';

@Injectable()
export class SxSecurityService {
  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();
  private userIsLoggedIn: boolean = false;
  private refreshTokenKey: string = "soc_refreshToken";

  constructor(
    private sxHttp: SxHttpService,
    private router: Router,
    private cacheService: CacheService,
    private sxTranslationService: SxTranslationService
  ) {
    this.isLoggedIn().then((res) => {
      this.userIsLoggedIn = res;
    });
    this.isAuthenticatedSubject.next(this.userIsLoggedIn);
  }

  /**
   * Loguea un usuario en el sistema
   */
  login(
    username: string,
    password: string,
    lang: string,
    rol: string,
    rememberMe: Boolean,
    persistLanguage: Boolean
  ) {
    const params = new URLSearchParams();
    params.append('UserName', username);
    params.append('Password', password);
    params.append('LangCode', lang);
    params.append('Rol', rol);
    params.append('RememberMe', rememberMe.toString());
    params.append('PersistLanguage', persistLanguage.toString());
    const body = params.toString();

    // Las credenciales de login se envian como x-www-form-urlencoded
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };

    return this.sxHttp
      .post('api/Authentication/Login', body, {}, headers)
      .map((response) => {
        this.isAuthenticatedSubject.next(true);
        let jResponse = response.json();
        let context = jResponse.data.apiContext;
        this.cacheService.setContext(context);
        localStorage.setItem(this.refreshTokenKey, jResponse.data.refreshToken);
      })
      .toPromise()
      .catch(this.handleError);
  }

  updateRoles() {
    return this.sxHttp
      .get('api/Authentication/UpdateRoles')
      .map((response) => {})
      .toPromise()
      .catch(this.handleError);
  }

  logout() {
    localStorage.removeItem(this.refreshTokenKey);
    this.removeJwt().then((res) => {
      this.isAuthenticatedSubject.next(false);
      this.router.navigateByUrl('login');
      localStorage.removeItem('currentUser');
    });
  }

  removeJwt(): Promise<boolean> {
    return this.sxHttp
      .post('api/Authentication/RemoveJwt', {})
      .map((response) => {
        return response.json().data as boolean;
      })
      .toPromise()
      .catch(this.handleError);
  }

  /**
   * @return Retorna true si el usuario esta logueado, sino retorna false
   */
  isLoggedIn(): Promise<boolean> {
    return this.sxHttp
      .post('api/Authentication/IsLoggedIn', {})
      .map((response) => {
        return response.json().data as boolean;
      })
      .toPromise()
      .catch((err) => this.userAutenthicationFailed(err));
  }

  private userAutenthicationFailed(error: any): Promise<any> {
    this.userIsLoggedIn = false;
    return null;
  }

  // TODO: mover el manejo de errores al SxHttpService
  private handleError(error: any): Promise<any> {
    console.error('Ocurrió un error', error);
    return Promise.reject(error.message || error.json());
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }

  updateDynamicSecAttr(
    systemCode: string,
    businessCode: string
  ): Observable<any> {
    var url = `api/Security/UpdateDynamicSecAttr/${systemCode}/${businessCode}`;
    return this.sxHttp.get(url).map((response) => response.json().data);
  }
}

/**
 * A guard which determines if a user can access an associated route.
 */
@Injectable()
export class AuthenticatedGuard implements CanActivate {
  constructor(private auth: SxSecurityService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isLoggedIn()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/sxSecurity.service.ts